<template>
  <modal
    :show="true"
    :large="true"
    v-on:close="closeOccupantModal"
    :enable-event="!alertIsOpen"
  >
    <h4 slot="title">Edit Occupant</h4>
    <div class="row">
      <fieldset
        :disabled="readonly"
        style="border:0;padding:0;margin:0;min-width:0;"
      >
        <div class="col-xl-12">
          <div class="form-horizontal">
            <selectlist
              :options="types"
              v-model="form.type_id"
              label="Occupant Type"
              name="type"
              placeholder="Please Select"
            ></selectlist>

            <inputbox
              v-model="form.first_name"
              name="first_name"
              label="First Name"
            ></inputbox>

            <inputbox
              v-model="form.last_name"
              name="last_name"
              label="Last Name"
            ></inputbox>

            <date-of-birth
              :required="true"
              v-model="form.date_of_birth"
              :unlimited="true"
            ></date-of-birth>

            <inputbox
              v-model="form.occupation"
              name="occupation"
              label="Occupation"
            ></inputbox>

            <inputbox
              v-model="form.medical_conditions"
              name="medical_conditions"
              label="Medical Conditions"
            ></inputbox>

            <inputbox
              v-model="form.relation_to_third_party"
              name="relation_to_third_party"
              label="Relation to Third Party"
            ></inputbox>

            <inputbox
              v-model="form.national_insurance"
              name="national_insurance_number"
              label="National Insurance Number"
            ></inputbox>

            <selectlist
              :options="positions"
              v-model="form.position_id"
              label="Seat/Position"
              name="position"
              placeholder="Please Select"
            ></selectlist>

            <toggleswitch
              :labels="true"
              name="requires_glasses"
              label="Requires Glasses?"
              v-model="form.requires_glasses"
            ></toggleswitch>

            <toggleswitch
              :labels="true"
              name="wearing_seatbelt"
              label="Wearing Seatbelt?"
              v-model="form.wearing_seatbelt"
            ></toggleswitch>

            <fieldset>
              <legend>
                Contact Details
                <small class="text-muted"
                  >- Enter the occupants contact details here</small
                >
              </legend>

              <inputbox
                v-model="form.telephone"
                name="telephone"
                label="Telephone"
              ></inputbox>

              <inputbox
                v-model="form.email_address"
                name="email"
                label="Email Address"
                type="email"
              ></inputbox>
            </fieldset>
            <fieldset>
              <legend>
                Address Details
                <small class="text-muted"
                  >- Enter the occupants address details here</small
                >
              </legend>
              <address-lookup
                :address="address"
                v-on:address="setAddress"
              ></address-lookup>
            </fieldset>

            <fieldset>
              <legend>
                Injury Details
                <small class="text-muted"
                  >- Enter the occupants injury details here</small
                >
              </legend>

              <input-block
                v-model="form.injury_details"
                name="injury_details"
                label="Injury Details"
                helper="Please enter a description of the occupant's injury"
              ></input-block>

              <toggleswitch
                :labels="true"
                name="has_representation"
                label="Has Representation?"
                helper="Does the occupany have representation already?"
                v-model="form.has_representation"
              ></toggleswitch>

              <div v-if="form.has_representation">
                <inputbox
                  v-model="form.representation_company_name"
                  name="representation_company_name"
                  label="Company Name"
                  helper="Please enter the name of the company representing the occupant"
                ></inputbox>

                <inputbox
                  v-model="form.representation_reference"
                  name="representation_reference"
                  label="Reference"
                  helper="Please enter the reference for the occupants injury"
                ></inputbox>

                <inputbox
                  v-model="form.representation_email"
                  name="representation_email"
                  label="Email"
                  helper="Please enter an email address for the company representing the occupant"
                ></inputbox>

                <inputbox
                  v-model="form.representation_telephone"
                  name="representation_telephone"
                  label="Telephone"
                  helper="Please enter a telephone number for the company representing the occupant"
                ></inputbox>
              </div>

              <toggleswitch
                :labels="true"
                name="any_lacerations"
                label="Any lacerations?"
                helper="Any lacerations?"
                v-model="form.any_lacerations"
              ></toggleswitch>
              <toggleswitch
                :labels="true"
                name="any_bleeding"
                label="Any bleeding?"
                helper="Any bleeding?"
                v-model="form.any_bleeding"
              ></toggleswitch>
              <toggleswitch
                :labels="true"
                name="any_head_wounds"
                label="Any head wounds?"
                helper="Any head wounds?"
                v-model="form.any_head_wounds"
              ></toggleswitch>
              <toggleswitch
                :labels="true"
                name="any_disorientation"
                label="Any disorientation?"
                helper="Any disorientation?"
                v-model="form.any_disorientation"
              ></toggleswitch>
              <toggleswitch
                :labels="true"
                name="any_fractures_or_breaks"
                label="Any fractures or breaks?"
                helper="Any fractures or breaks?"
                v-model="form.any_fractures_or_breaks"
              ></toggleswitch>
              <toggleswitch
                :labels="true"
                name="any_fatalities"
                label="Any fatalities?"
                helper="Any fatalities?"
                v-model="form.any_fatalities"
              ></toggleswitch>
              <toggleswitch
                :labels="true"
                name="any_loss_of_consciousness"
                label="Was there any loss of consciousness?"
                helper="Was there any loss of consciousness?"
                v-model="form.any_loss_of_consciousness"
              ></toggleswitch>
              <toggleswitch
                :labels="true"
                name="police_attend"
                label="Did the police attend?"
                helper="Did the police attend?"
                v-model="form.police_attend"
              ></toggleswitch>
              <toggleswitch
                :labels="true"
                name="ambulance_or_air_ambulance_attend"
                label="Did an ambulance or air ambulance attend?"
                helper="Did an ambulance or air ambulance attend?"
                v-model="form.ambulance_or_air_ambulance_attend"
              ></toggleswitch>
            </fieldset>
          </div>
        </div>
      </fieldset>
    </div>
    <div slot="footer">
      <div class="float-left">
        <form-button
          :indicator="indicator"
          v-on:clicked="deleteOccupant"
          level="danger"
          v-if="!readonly"
          >Delete</form-button
        >
      </div>
      <button
        type="button"
        v-on:click="closeOccupantModal"
        class="btn btn-danger"
      >
        Close
      </button>
      <form-button
        :indicator="form.processing()"
        v-on:clicked="updateThirdPartyOccupant"
        v-if="!readonly"
        >Update Occupant</form-button
      >
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },

    types: {
      type: Array,
      required: true
    },

    positions: {
      type: Array,
      required: true
    },

    thirdParty: {
      type: Object,
      required: true
    },

    occupant: {
      type: Object,
      required: true
    },

    readonly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      alertIsOpen: false,
      form: new window.Form({
        type_id: this.occupant.type_id,
        first_name: this.occupant.first_name,
        last_name: this.occupant.last_name,
        date_of_birth: this.occupant.date_of_birth
          ? this.occupant.date_of_birth
          : null,
        occupation: this.occupant.occupation,
        medical_conditions: this.occupant.medical_conditions,
        relation_to_third_party: this.occupant.relation_to_third_party,
        national_insurance: this.occupant.national_insurance,
        position_id: this.occupant.position_id,
        requires_glasses: this.occupant.requires_glasses,
        wearing_seatbelt: this.occupant.wearing_seatbelt,
        telephone: this.occupant.telephone,
        email_address: this.occupant.email_address,
        address_line_one: this.occupant.address_line_one,
        address_line_two: this.occupant.address_line_two,
        city: this.occupant.city,
        postcode: this.occupant.postcode,
        injury_details: this.occupant.injury_details,
        has_representation: this.occupant.has_representation,
        representation_company_name: this.occupant.representation_company_name,
        representation_reference: this.occupant.representation_reference,
        representation_email: this.occupant.representation_email,
        representation_telephone: this.occupant.representation_telephone,
        any_lacerations: this.occupant.any_lacerations,
        any_bleeding: this.occupant.any_bleeding,
        any_head_wounds: this.occupant.any_head_wounds,
        any_disorientation: this.occupant.any_disorientation,
        any_fractures_or_breaks: this.occupant.any_fractures_or_breaks,
        any_fatalities: this.occupant.any_fatalities,
        any_loss_of_consciousness: this.occupant.any_loss_of_consciousness,
        police_attend: this.occupant.police_attend,
        ambulance_or_air_ambulance_attend: this.occupant
          .ambulance_or_air_ambulance_attend
      }),
      indicator: false
    };
  },

  computed: {
    address() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    }
  },

  methods: {
    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    },

    deleteOccupant() {
      this.alertIsOpen = true;

      window
        .swal({
          title: 'Are you sure?',
          text: 'You cannot undo this',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.indicator = true;
            window.Ajax.delete(
              `/incidents/${this.incident}/third-parties/${this.thirdParty.identifier}/occupants/${this.occupant.identifier}`
            )
              .then(response => {
                this.$emit('deleted', this.occupant);
                this.indicator = false;
              })
              .catch(error => {
                this.indicator = false;
                window.toastify.error(
                  'Error',
                  'Sorry, there was an error deleting the occupant.'
                );
              });
          }
        })
        .catch(error => {
          setTimeout(() => {
            this.alertIsOpen = false;
          }, 500);
        });
    },

    closeOccupantModal() {
      if (this.readonly) {
        this.$emit('close');
        return;
      }

      this.alertIsOpen = true;

      window
        .swal({
          title: 'Are you sure?',
          text: 'You will lose any unsaved changes',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.$emit('close');
          }
        })
        .catch(error => {
          setTimeout(() => {
            this.alertIsOpen = false;
          }, 500);
        });
    },

    updateThirdPartyOccupant() {
      this.form
        .put(
          `/incidents/${this.incident}/third-parties/${this.thirdParty.identifier}/occupants/${this.occupant.identifier}`
        )
        .then(response => {
          this.$emit('updated', response);
        })
        .catch(response => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error updating the incident'
          );
        });
    }
  }
};
</script>
